import { __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { components } from 'react-select';
import styles from './Dropdown.module.scss.js';

// Do not move this Component to main Component return: https://github.com/JedWatson/react-select/issues/2810#issuecomment-569117980
var DropdownControl = function (props) {
    var _a = props.selectProps, label = _a.inputId, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, isValid = _a.isValid, trigger = _a.trigger, controlClassName = _a.controlClassName, testId = _a.testId, primaryCondition = _a.primaryCondition, primaryConditionClassName = _a.primaryConditionClassName, secondaryCondition = _a.secondaryCondition, isMultilineSecondaryCondition = _a.isMultilineSecondaryCondition, secondaryConditionClassName = _a.secondaryConditionClassName;
    var menuIsOpen = props.menuIsOpen, children = props.children, isFocused = props.isFocused;
    var controlWrapperStyle = clsx(styles.ControlWrapper, isDisabled && styles.ControlWrapper___disabled, isReadOnly && styles.ControlWrapper___isReadOnly, !isDisabled && !isValid && styles.ControlWrapper___error);
    // control styling
    var controlStyle = '';
    if (trigger) {
        controlStyle = styles.ControlWrapper_control___borderless;
    }
    else {
        if (menuIsOpen) {
            controlStyle = styles.ControlWrapper_control___focus;
        }
        else if (!isValid) {
            controlStyle = styles.ControlWrapper_control___error;
        }
        else if (isFocused) {
            controlStyle = styles.ControlWrapper_control___focusVisible;
        }
    }
    controlStyle = clsx(styles.ControlWrapper_control, controlStyle, controlClassName);
    return (React__default.createElement("div", { className: controlWrapperStyle, "data-testid": props.selectProps['data-testid'] || testId },
        (label || primaryCondition) && (React__default.createElement("div", { className: styles.ControlWrapper_top },
            label ? (React__default.createElement("label", { className: clsx(styles.ControlWrapper_label, styles.ControlWrapper_label___label), htmlFor: label }, label)) : null,
            !trigger && primaryCondition && (React__default.createElement("div", { className: clsx(styles.ControlWrapper_label, styles.ControlWrapper_label___primaryCondition, primaryConditionClassName) }, primaryCondition)))),
        React__default.createElement(components.Control, __assign({ className: controlStyle }, props),
            trigger,
            children),
        !trigger && secondaryCondition && (React__default.createElement("div", { className: clsx(styles.ControlWrapper_label, isMultilineSecondaryCondition
                ? styles.ControlWrapper_label___isMultiline
                : styles.ControlWrapper_label___secondaryCondition, secondaryConditionClassName) }, secondaryCondition))));
};
DropdownControl.displayName = 'DropdownControl';

export { DropdownControl as default };
